import { ReactElement } from 'react';
import { AnnouncementCardPropTypes } from '../../types/propTypes/AnnouncementCardPropTypes';
import { PanelType } from '../../types/PanelType';
import Panel from '../Panel/Panel';
import AnnouncementSubPanel from './AnnouncementSubPanel';

const AnnouncementCard = ({
  panelTitle,
  subpanels
}: AnnouncementCardPropTypes): ReactElement => (
  <Panel panelType={PanelType.INFO} heading={panelTitle}>
    {subpanels.map((item) => (
      <AnnouncementSubPanel
        key={item.id}
        panelText={item.panelText}
        panelUrl={item.panelUrl}
        panelUrlText={item.panelUrlText}
      />
    ))}
  </Panel>
);

export default AnnouncementCard;
